import { defineStore } from 'pinia';
import type { UserInfo } from '../services/SettingsService.ts';

export const useUserStore = defineStore('user', {
  state: () => ({
    userName: '',
    userInitials: '',
    userInfo: null as UserInfo | null,
  }),
  actions: {
    setUserName(name: string) {
      this.userName = name;
    },
    setUserInitials(initials: string) {
      this.userInitials = initials;
    },
    setUserInfo(info: UserInfo) {
      this.userInfo = info;
    },
  },
});